export enum ACTION_TYPES {
  SET_HUB_INVENTORY = 'SET_HUB_INVENTORY',
  SET_SHIPMENT_NEXT_STEP = 'SET_SHIPMENT_NEXT_STEP',
  SET_BATCH_HUB_OUT_DONE = 'SET_BATCH_HUB_OUT_DONE',
  SET_RETURNED_SHIPMENTS = 'SET_RETURNED_SHIPMENTS',
  MASS_SET_HUB_INVENTORY_TYPE_UNSCANNABLE = 'MASS_SET_HUB_INVENTORY_TYPE_UNSCANNABLE',
}

export enum ITYPES {
  BACK_TO_TRUNKRS = 'BACK_TO_TRUNKRS',
  KEEP_IN_REGION = 'KEEP_IN_REGION',
  ERROR = 'ERROR',
  UNSCANNABLE = 'UNSCANNABLE',
}

export interface IReturnedShipments {
  shipmentId: number
  type: ITYPES
}
